"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var PartnerLogo = function PartnerLogo(props) {
  var src = props.src,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$srcSet = props.srcSet,
    srcSet = _props$srcSet === void 0 ? '' : _props$srcSet,
    _props$maxWidth = props.maxWidth,
    maxWidth = _props$maxWidth === void 0 ? 500 : _props$maxWidth,
    className = props.className;
  return /*#__PURE__*/_react["default"].createElement(Link, {
    href: "/",
    isMobile: isMobile,
    className: "header-logo ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement(Logo, {
    srcSet: srcSet,
    src: src,
    alt: "",
    $maxWidth: maxWidth
  }));
};
var Link = _styledComponents["default"].a.withConfig({
  displayName: "PartnerLogo__Link",
  componentId: "sc-1secbcd-0"
})(["display:inline-block;width:", "px;height:60px;max-height:100%;margin:0 5px 0 0;"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 60 : 200;
});
var Logo = _styledComponents["default"].img.withConfig({
  displayName: "PartnerLogo__Logo",
  componentId: "sc-1secbcd-1"
})(["max-width:", "px;height:100%;object-fit:contain;"], function (_ref2) {
  var $maxWidth = _ref2.$maxWidth;
  return $maxWidth;
});
var _default = exports["default"] = PartnerLogo;